<template>
    <div class="animated fadeIn">
        <loader v-if="loading"></loader>
        <div v-if="!loading">
            <component-header
                title="My Invoice History"
                @reload-data="getPartnerInvoiceListData"
                :isLoading="isloading"
                :hasCreate="false"
                :hasback="true"
                :hasUnbilliedInvoice="true"
                @unbillied-invoice-press="
                    $router.push('/myaccount/my-invoice/unbilled')
                "
                @back-press="$router.push('/myaccount')"
                @search-query="(val) => (filter = val)"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        :filter="filter"
                        responsive="sm"
                        :items="invoiceList"
                        :fields="invoiceColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        show-empty
                    >
                        <template slot="action" slot-scope="data">
                            <b-button
                                @click="viewDetails(data)"
                                size="sm"
                                class="mr-2"
                                variant="primary"
                            >
                                <i
                                    style="color: white !important"
                                    class="far fa-eye edit"
                                ></i>
                            </b-button>
                        </template>
                        <template slot="empty">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>

                        <!-- <template slot="status" slot-scope="data">
              <p>
                <img src="img/Ellipse63.png" alt="" /> {{ data.item.status }}
              </p>
            </template> -->
                    </b-table>
                </div>
                <div class="float-right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="invoiceList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
    name: "InvoiceHistory",
    components: {
        ebButton,
        ComponentHeader,
        loader,
    },
    data() {
        return {
            loading: true,
            isloading: false,
            currentPage: 1,
            perPage: 10,
            filter: "",
            invoiceColumns: [
                {
                    key: "id",
                    sortable: true,
                },
                {
                    key: "billStartDate",
                },
                {
                    key: "billEndDate",
                },
                {
                    key: "description",
                },
                {
                    key: "billDueDate",
                },
                {
                    key: "invoiceDate",
                },
                {
                    key: "tax",
                },
                {
                    key: "charge",
                },
                {
                    key: "total",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            getPartnerInvoice: "invoice/GetMyInvoiceHistoryPartner",
        }),

        invoiceList() {
            let data = this.getPartnerInvoice;
            let invoiceList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let num = obj.invoiceNumber.toString();
                    while (num.length < 10) num = "0" + num;
                    let arrObj = {
                        _id: obj._id,
                        id: "#" + num,
                        status: obj.status,
                        billStartDate: this.getProperDate(obj.startDate),
                        billEndDate: this.getProperDate(obj.endDate),
                        description: `Invoice for Amount INR ${obj.totalAmount.toFixed(
                            2
                        )} generated for period ${this.getProperDate(
                            obj.startDate
                        )} to  ₹ ${this.getProperDate(obj.endDate)}`,
                        billDueDate: this.getProperDate(obj.dueDate),
                        invoiceDate: this.getProperDate(obj.createdAt),
                        tax: obj.totalTaxes.toFixed(2),
                        charge: obj.chargeAmount.toFixed(2),
                        total: obj.totalAmount.toFixed(2),
                        ...obj,
                    };
                    invoiceList.push(arrObj);
                });
                return invoiceList.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                );
            } else {
                return [];
            }
        },
    },
    methods: {
        viewDetails(data) {
            this.$store.dispatch("invoice/singlePartnerInvoice", data.item);
            this.$router.push({ path: "my-invoice/details" });
        },
        async getPartnerInvoiceListData() {
            this.isloading = true;
            await this.$store.dispatch("invoice/fetchMyInvoiceHistoryPartner");
            this.isloading = false;
        },
        getProperDate(data) {
            if (data != null) {
                let date = new Date(data);

                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "Unavailable";
            }
        },
    },

    async mounted() {
        this.loading = true;
        await this.$store.dispatch("invoice/fetchMyInvoiceHistoryPartner");
        this.loading = false;
    },
};
</script>
